import { render } from "./Page3Item.vue?vue&type=template&id=8c897720"
import script from "./Page3Item.vue?vue&type=script&lang=js"
export * from "./Page3Item.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__